import { useLoadScript } from '@react-google-maps/api';

const LIBS = ['places'];

function DefaultMapSkeleton() {
  return (
    <div role="status" aria-busy="true" className="animate-pulse space-y-4">
      <div className="mx-auto w-3/4 h-10 bg-gray-200 rounded" />
      <div className="w-full bg-gray-200 rounded" style={{ height: 320 }} />
      <div className="flex gap-2">
        <div className="h-4 bg-gray-200 rounded w-1/4" />
        <div className="h-4 bg-gray-200 rounded w-1/3" />
        <div className="h-4 bg-gray-200 rounded w-1/6" />
      </div>
    </div>
  );
}

export default function MapsLoader({ children, fallback = null }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: LIBS,
    // optionally: preventGoogleFontsLoading: true
  });

  if (loadError) return <div className="text-red-600">Failed to load maps</div>;
  if (!isLoaded) return (fallback || <DefaultMapSkeleton />);
  return children;
}